module.exports = __webpack_public_path__ + "images/skillzBrandedInfoIcon-4a622331eb1883df0dea570daa5b85ba.svg";